import axios from "axios";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const GET_ACTIVE_TOKEN = "GET_ACTIVE_TOKEN";
export const GET_EMPLEADORES = "GET_EMPLEADORES";
export const LOGIN_AS_EMPLEADOR = "LOGIN_AS_EMPLEADOR";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const RECOVER_PASSWORD = "RECOVER_PASSWORD";
export const CHANGE_RECOVERY_PASSWORD = "CHANGE_RECOVERY_PASSWORD";

export const login = (values) => (dispatch) => {
  return dispatch({
    type: LOGIN,
    payload: axios
      .post("auth/login", values)
      .then((response) => ({ data: { ...response.data } }))
      .catch((error) => Promise.reject(error)),
  });
};

export const isActiveToken = () => (dispatch) => {
  return dispatch({
    type: GET_ACTIVE_TOKEN,
    payload: axios
      .get("auth/activeToken")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const logout = () => {
  delete axios.defaults.headers.common["Authorization"];
  return {
    type: LOGOUT,
  };
};

export const getEmpleadores = () => (dispatch) => {
  return dispatch({
    type: GET_EMPLEADORES,
    payload: axios
      .get("empleador/empleadoresUsuarioProductor")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const loginAsEmpleador = (values) => (dispatch) => {
  return dispatch({
    type: LOGIN,
    payload: axios.get(`auth/asociarEmpleadorProductor?idEmpleador=${values.empleador}&version=${values.version}`, values.empleador)
      .then((response) => ({ data: { ...response.data, empleador: values.empleador, nombreEmpleador: values.nombreEmpleador } }))
      .catch((error) => Promise.reject(error)),
    meta: { asEmpleador: true }
  })
}

export const changePassword = (values) => (dispatch) => {
  return dispatch({
    type: CHANGE_PASSWORD,
    payload: axios.post(`auth/cambiarClave?claveAnterior=${encodeURIComponent(values.claveAnterior)}&claveNueva=${encodeURIComponent(values.claveNueva)}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
} 

export const recoverPassword = (username) => (dispatch) => {
  return dispatch({
    type: RECOVER_PASSWORD,
    payload: axios.post(`auth/recuperarClave?usuario=${encodeURIComponent(username)}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const changeRecoveryPassword = (values) => (dispatch) => {
  return dispatch({
    type: CHANGE_RECOVERY_PASSWORD,
    payload: axios.post(`auth/cambiarClaveRecuperacion?usuario=${encodeURIComponent(values.usuario)}&claveRecuperacion=${encodeURIComponent(values.claveRecuperacion)}&claveNueva=${encodeURIComponent(values.claveNueva)}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};